import React from "react";
import IssuerCompanyCard from "./IssuerCompanyCard";

const IssuerCompanySelector = ({ companies, selectedId, onSelect, onChangeCompany }) => {
	return (
		<section style={{ marginBottom: "24px" }}>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					marginBottom: "12px",
					flexWrap: "wrap",
					gap: "8px",
				}}
			>
				<div>
					<h5 style={{ marginBottom: "4px" }}>1. Empresa emisora</h5>
					<p style={{ marginBottom: 0, color: "#4a5568" }}>
						La empresa seleccionada determina el tratamiento tributario de toda la cotización.
					</p>
				</div>
				{selectedId && onChangeCompany ? (
					<button
						type="button"
						className="button hollow secondary"
						style={{ marginBottom: 0 }}
						onClick={onChangeCompany}
					>
						Cambiar empresa emisora
					</button>
				) : null}
			</div>

			<div className="grid-x grid-margin-x">
				{companies.map((company) => (
					<IssuerCompanyCard
						key={company.id}
						company={company}
						selected={selectedId === company.id}
						onSelect={onSelect}
					/>
				))}
			</div>
		</section>
	);
};

export default IssuerCompanySelector;
